import React from "react";

const PublicCatalogFooter = () => {
  return (
    <div className="catalog-footer">
      <div className="container">
        ©Jaguar Design Studio
      </div>
    </div>
  )
}

export default PublicCatalogFooter